<template>
   <div>
    <div v-for="(data, index) in sections" :key="data.id" :id="'section-' + index" class="image-container">
        <img class="paste-image-icon" alt="" :src="'/api/image/get/'+data.landingPageImage" />

        <!-- <div v-if="index != sections.length - 1" @click="scrollToContent(index + 1)" class="scroll-to-next-section">
            <span>
                <img alt="" class="iconAngle-down mb-2" src="@/assets/icons/fi-rr-angle-double-small-right-white.svg" />
                <span class="d-none d-md-inline">{{ sections[index + 1].name }}</span>
            </span>
        </div> -->

        <!-- <div v-if="index == sections.length - 1" @click="goTopPage" class="scroll-to-next-section">
            <span>
                <img alt="" class="iconAngle-up mr-2 text-center" src="@/assets/icons/fi-rr-angle-double-small-right-white.svg" />
            </span>
        </div> -->

        <div class="over-image">
            <div class="common-title-class tag mb-4">{{ data.name }}</div>
            <div class="button-title  common-title-class" @click="setSectionId(data.id)">Je découvre</div>
        </div>

        <div class="over-image-scroll ">
            <div v-if="index != sections.length - 1" @click="scrollToContent(index + 1)" class="scroll-to-next-section" >
                    <img alt="" class="iconAngle-down" src="@/assets/icons/fi-rr-angle-double-small-right-white.svg" />
                    <!-- <span class="d-none d-md-inline">{{ sections[index + 1].name }}</span> -->
            </div>

            <div v-if="index == sections.length - 1" @click="goTopPage" class="scroll-to-next-section">
            <span>
                <img alt="" class="iconAngle-up text-center" src="@/assets/icons/fi-rr-angle-double-small-right-white.svg" />
            </span>
        </div>

        </div>
    </div>
</div>

</template>


<script>
import ItemsApi from "@/services/items-api";

export default ({
    name: "LandingPage",

    data() {
    return {
        sections : null ,
    }},

    mounted(){

        this.makeRedirection();
        this.getAllSection()
    },

    methods: {

     setSectionId(sectionId){        
        this.$store.commit('setMainSectionId', sectionId);
        this.makeRedirection();    
    },

    makeRedirection() {

        if (!this.$store.state.mainSectionId) {
            return;
        }

        if (this.$route.query.redirectFrom ) {
            this.$router.push(
                this.$route.query.redirectFrom || { name: "default" }
            );
           
        } else {
            this.$router.push({ name: "default" });
        }
    },

    getAllSection(){
        ItemsApi.getAllSection().then(
            result =>{
                this.sections = result 
            }
        )
    },

    scrollToContent(index) {
  const targetElement = document.getElementById('section-' + index);

  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'end' // Ensure the bottom of the element is aligned to the bottom of the viewport
    });
  }
}


,

    goTopPage() {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
    }
}
})

</script>
<style scoped>

.vertical-text {
  writing-mode: vertical-lr; 
  text-orientation: upright;
}

.scroll-to-next-section {
    /*position: absolute;
    top: 50%;
    right: 2%;
    top: calc(50% - -30%);
    transform: translate(-50%, -50%);
    color: #fff;*/
    font-size:40px;
    cursor: pointer;


    
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    animation: moveDown 2s infinite alternate; 
}

.scroll-to-next-section:hover {
    animation-play-state: paused;
}

@keyframes moveDown {
    0% {
        transform: translate(0%, 0%);
    }
    100% {
        transform: translate(0%, 25%); 
    }
}

.paste-image-icon {
    position: relative;
    width: 100%;
    height: 100vh;
    object-fit: cover;
}

.image-container {
    position: relative;
    overflow: hidden;
}

.overlay-text {
    position: relative;
    bottom: 5;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 50px;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-family: 'Space Grotesk';

}

.common-title-class {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
    display: inline-block;
    width: 150px;
}

.button-title {
    border-radius: 6px;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    background-color: #fff;
    width: 100%;
    flex-direction: row;
    padding: 10px 26px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    color: #000;
    font-family: 'Space Grotesk';
}

.over-image {
    position: absolute;
    /*top: 0%;*/
    left: 50%;
    top: calc(35% - -30%);
    transform: translate(-50%, -50%);

}

.over-image-scroll {
    position: absolute;
    /*top: 55%;*/
    left: 50%;
    top: calc(50% - -30%);
    transform: translate(-50%, -50%);

}

.tag {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
    display: inline-block;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    line-height: 32px;
    font-family: 'Space Grotesk';
    color: #fff;
    text-align: center;
    display: inline-block;
    width: 250px;
    height: 45px;
}

.iconAngle-down {
    transform: rotate(90deg);
    width: 40px; 
    height: 40px;
}

.iconAngle-up {
    transform: rotate(-90deg);
    width: 40px; 
    height: 40px;

}


</style>